module.exports = __webpack_public_path__ + "static/media/cluster-background.2e61eda8.svg";